// @flow

import sharedDialogStyles from '../../Styles/SharedDialogStyles';

const removeTenantDialogStyles = {
  // Import shared styles
  ...sharedDialogStyles,

  flexContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  }),

  grow: (theme) => ({
    flexGrow: 1,
    overflowY: 'visible'
  })
};

export default removeTenantDialogStyles;